import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ds-sub-dashboard-card',
  templateUrl: './ds-sub-dashboard-card.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class DsSubDashboardCardComponent {
  @Input() id: string = '';
  @Input() iconSrc: string = '';
  @Input() text: string = '';
  @Input() chevronIconSrc: string = '';

  @Output() cardClick = new EventEmitter<void>();

  onCardClick() {
    this.cardClick.emit();
  }
}
